(function () {
  var FilterLayer = {
    selectedData: null,
    filterValues: [],
    fliterUrl:"",

    init: function () {
      var self = this;

      vcui.require(["ui/rangeSlider"], function () {
        self.setting();
        self.bindEvents();
        self._filterBindCustomEvents();
        self.mobileSlideReload();
        self._filterSliderResetStart();

        self.create();

        self.select();
      });
    },

    setting: function () {
      var self = this;

      self.$layFilter = $(".lay-filter-con:last");
      self.$bfilterTagList = self.$layFilter.find(".select-filter-list");

      // 20230823 추가
      self.$layFilter2 = $(".lay-filter-con-plp");
      self.$bfilterTagList2 = self.$layFilter2.find(".select-filter-list");
      self.$bfilterTagList2_1 = self.$layFilter2.find(".lay-filter-con-plp-inner");

      self.$btnRefresh = self.$layFilter.find(".btn-refresh");
      self.$btnRefresh2 = self.$bfilterTagList2_1.find(".btn-refresh");
      self.$bfilterChks = self.$layFilter.find(
        ".chk-wrap, .rdo-wrap, .chk-wrap-colorchip"
      );
      self.$btnAfilter = $(".afilter-btn-area").children(".btn-afilter");
      self.$btnAfilterClose = $('.plp-new-section-filter-cont .filter-close .btn-close');
      self.$btnAfilterDimmed = $('.plp-new-section-filter-cont .lay-filter .dimmed');
    },

    //커스텀 필터 이벤트 (필터 리스트를 새로 그리면 매번 실행할것)
    _filterBindCustomEvents: function () {
      var self = this;
      if (!self.$layFilter) {
          return;
      }
      // 필터안 슬라이더 이벤트 처리 (가격, 사이즈,..)
      self.$layFilter.find(".ui_filter_slider").on("rangesliderinit rangesliderchange rangesliderchanged", function (e, data) {
          $(e.currentTarget).siblings(".min").text(vcui.number.addComma(data.minValue.title + "원"));
          $(e.currentTarget).siblings(".max").text(vcui.number.addComma(data.maxValue.title + "원"));
          var slideClass = $(this).parents(".is-range-slider").children("div").attr("class");
          var slideName = $(this).parents(".is-range-slider").find(".tit_result_count").text();
          if (e.type == "rangesliderchanged") {
            $(this).attr({ "data-min": data.minValue.value, "data-max": data.maxValue.value });
            var checkMin = $(this).attr("data-min");
            var checkMax = $(this).attr("data-max");
            var checkRangeMin = $(this).find(".ui-range-slider-value").find("li:First-child").attr("data-value");
            var checkRangeMax = $(this).find(".ui-range-slider-value").find("li:last-child").attr("data-value");
            var checkId = $(this).attr("data-filter-id");
            if(checkMin == checkRangeMin && checkMax == checkRangeMax){
              void 0;
              $(this).parents(".plp-new-section-product-list").find("." + checkId).next(".btn-del").trigger("click");;
            }
            else {
              $(this).parents(".plp-new-section-product-list").find(".lay-filter-con-plp-inner ul " + "." + slideClass).parent("li").remove(".is-num-slider");
              $(this).parents(".plp-new-section-product-list").find(".lay-filter-con-plp-inner ul")
              .prepend(
                '<li class="is-num-slider">' +
                '<div class="' + slideClass + '">' +
                '<div class="s-fliter"><span class="' +
                checkId + '">' +
                slideName + " " +
                data.minValue.title + "원" + " ~ " + data.maxValue.title + "원" +
                  '</span><button type="button" data-value="' +
                  data.minValue.title + "원" + " ~ " + data.maxValue.title + "원" +
                  '" class="btn-del delete-content"><span class="blind">삭제</span></button></div></div></li>'
              );
              $(this).parents(".plp-new-section-product-list").find(".lay-filter-con-plp").addClass("active2");
              $(this).parents(".plp-new-section-product-list").find(".lay-filter-con-plp-inner").addClass("on");
              $(this).parents(".plp-new-section-product-list").find("#filterWrap").addClass("is-filter-selected");
            }
          }
      });
    },

    mobileSlideReload: function() {
      var self = this;
      self.$layFilter.parents(".component.KRP0007.re22").on("click", ".btn-afilter", function(){
        setTimeout(function(){
          self.$layFilter.parents(".lay-filter").find(".ui_filter_slider").vcRangeSlider("update", true);
          void 0;
        }, 1000);
      });
    },

    _filterSliderResetStart: function () {
      var self = this;
      self.$layFilter.find(".range-wrap-new").each(function(){
        var slideContent = $(this).find(".ui_filter_slider");
        var slideContentOption = slideContent.attr("data-range");
        slideContent.vcRangeSlider("reset", slideContentOption);
      });
    },

    bindEvents: function () {
      var self = this;

      $(window).on('filterSlider.reset', function() {
        var self = this;
        self.$layFilter.find(".range-wrap-new").each(function(){
          var slideContent = $(this).find(".ui_filter_slider");
          var slideContentOption = slideContent.attr("data-range");
          slideContent.vcRangeSlider("reset", slideContentOption);
        });
      });

      // bfilter 상태 변경
      self.$bfilterChks.on("change", "input", function (e) {

        var $input = $(e.currentTarget);
        var filterName = $input.closest("li, .top-sort-content").find(".tit_result_count").text();
        var value = $input.next("label").text();

        var dataAttribute = "";
        if($input[0].attributes['data-attr-id'] && $input[0].attributes['data-attr-id'] != "undefined"){
          dataAttribute =  $input[0].attributes['data-attr-id'].value+'_'+$input[0].attributes['data-keywd-id'].value;
        }

        if ($input.prop("checked")) {
          if ($input.is('[type="radio"]')) {
            self.removeSelectedData(filterName, '', '',$input[0]);
          }
          self.addSelectedData(filterName, value, $input[0]);

          //s: BTOCSITE-55480 - 노트북 PLP 개선 - 일반 필터 영역  선택값 퀵필터에 노출 처리 추가(202402)
          if($input[0].attributes['data-attr-id'] && $input[0].attributes['data-attr-id'] != "undefined"){
              // 퀵필터에 없는 경우 추가 하는 로직
              var quickChkProductVal =  $('#quick_chk_product_'+dataAttribute).text().trim();

              // 다중 퀵필터 여부
              var mobileMultiFilterFlag = $('#mobileMultiFilterFlag').val();

              //일반 퀵필터 (다중 퀵필터 X)
              if(quickChkProductVal == '' && mobileMultiFilterFlag != 'Y'){
                  self.addSelectedQuickFilterData(filterName, value , $input);
              }

              if(mobileMultiFilterFlag == 'Y'){

                if($('#add_quick_chk_product_'+dataAttribute).text() !='' && $('#add_quick_chk_product_'+dataAttribute).text() != "undefined"){
                    void 0
                }else{
                  $('#quick_chk_product_'+dataAttribute).trigger('click');
                }
              }
          }
          //e: BTOCSITE-55480 - 노트북 PLP 개선 - 일반 필터 영역  선택값 퀵필터에 노출 처리 추가(202402)

        } else {

          self.removeSelectedData(filterName, value , dataAttribute, $input[0]);
        }

        self.select();
      });

      // 태그형 x 버튼
      self.$bfilterTagList.on("click", ".btn-del", function (e) {
        var target = $(e.currentTarget);

        var filterName = target.data("contents");
        var value = target.data("value");

        if (filterName && value) {
          self.removeSelectedData(filterName, value, '', target);

          self.select();
        }

        listItemSizeCheck();
      });

      // 20230823 추가 - BTOCSITE-40437
      self.$bfilterTagList2.on("click", ".btn-del", function (e) {
        var target = $(e.currentTarget);

        var filterName = target.data("contents");
        var value = target.data("value");

        if (filterName && value) {
          self.removeSelectedData(filterName, value, '', target);

          self.select();
        }

        listItemSizeCheck();
      });

      self.$bfilterTagList2_1.on("click", ".is-radio-type + .btn-del", function () {

        var deleteBtName = $(this).next().attr("class");
        var targetNative = $(".rdo-wrap").find("input[id=" + deleteBtName + "]")
        var target = targetNative;
        var filterName = target.closest("li, .top-sort-content").find(".tit_result_count").text();
        var value = target.next("label").text();
        self.removeSelectedData(filterName, value, '', target);

        self.select();

        listItemSizeCheck();
      });

      // 20230823 추가 - BTOCSITE-40437
      self.$bfilterTagList2_1.on("click", ".btn-del", function () {
        var tagCont = $(this).parent().parent();
        var tagCont2 = $(this).parent().parent().parent();
        var tagClass = tagCont.attr("class");
        var tagContainerSort = $(".filter-item-type-sort");
        var $input = $(".lay-filter").find("#" + tagClass);
        var filterName = $input.closest("li, .top-sort-content").find(".tit_result_count").text();
        var value = $input.next("label").text();
        var slideName = $(this).parents(".is-num-slider").children().attr("class");
        var slideContent = self.$layFilter.find(".is-range-slider").find("." + slideName).find(".ui_filter_slider");
        var slideContentOption = slideContent.attr("data-range");
        var radioSelectedPrev = $(this).prev();
        var radioSelectedParent = $(this).parent().parent().attr("class");
        tagCont.remove();
        if (filterName && value) {

          if(radioSelectedParent && radioSelectedParent !=''){
            var dataAttribute = radioSelectedParent.replaceAll('chk_product_', '');
            self.removeSelectedData(filterName, value , dataAttribute, $input[0]);
          }else{
            self.removeSelectedData(filterName, value , '', $input[0]);
          }

          self.select();
        }
        tagContainerSort.find("input:checkbox[id='" + tagClass + "']").prop("checked", false);
        if (self.$bfilterTagList2_1.find("li").not(".clear-all").length < 1) {
          self.$bfilterTagList2_1.removeClass("on");
          void 0;
        }
        void 0;
        if($(".plp-new-section-product-list").find(".lay-filter-con-plp-inner").find("li").length < 2) {
          $(".plp-new-section-product-list").find(".lay-filter-con").removeClass("is-filter-selected");
          $(".plp-new-section-product-list").find(".lay-filter-con-plp-inner").removeClass("on");
          $(".lay-filter-con-plp").removeClass("active2");
        }
        filterMovementEvent()
        if(tagCont2.hasClass("is-num-slider")) {
          tagCont2.remove(".is-num-slider");
          slideContent.vcRangeSlider("reset", slideContentOption);
          if (self.$bfilterTagList2_1.find("li").not(".clear-all").length < 1) {
            self.$bfilterTagList2_1.removeClass("on");
            $(".lay-filter-con").removeClass("is-filter-selected");
          }
        }
        if(radioSelectedPrev.hasClass("is-radio-type")) {
          $(".lay-filter").find(".rdo-wrap").find($("input[name~='" + radioSelectedParent + "']")).prop("checked", false);
        }

        listItemSizeCheck();
      });

      self.$bfilterTagList2_1.on("click", ".rdo-wrap .btn-del", function (e) {
        var target = $(e.currentTarget);

        var tagCont = $(this).parent().parent();
        var tagClass = tagCont.attr("class");
        var $input = $(".lay-filter").find("#" + tagClass);

        var filterName = target.data("contents");
        var value = target.data("value");

        if (filterName && value) {
          self.removeSelectedData(filterName, value, '', $input);

          self.select();
        }

        listItemSizeCheck();
      });

      self.$bfilterTagList2.on("click", ".clear-all .btn-refresh", function (e) {
        self.resetBfilter();
      });

      // 초기화 버튼
      self.$btnRefresh.off("click").on("click", function (e) {
        self.resetBfilter();
        $(".lay-filter-con-plp-inner").find(".s-filter-list").find("li").not(".clear-all").remove();
      });
      self.$btnRefresh2.off("click").on("click", function (e) {
        self.resetBfilter();
        $(".lay-filter-con-plp-inner").find(".s-filter-list").find("li").not(".clear-all").remove();
      });

      self.$btnAfilter.on("click", function() {
        FilterLayer.layfilterOpenEv();
        // FilterLayer.init();
      });

      self.$btnAfilterClose.on("click", function() {
        FilterLayer.layfilterCloseEv();
        // FilterLayer.init();
      });

      self.$btnAfilterDimmed.on("click", function() {
        FilterLayer.layfilterCloseEv();
        // FilterLayer.init();
      });
    },

    /**
     * 생성
     */
    create: function () {
      var self = this;

      // self.initVcui();
    },

    /**
     * vcui 초기화
     */
    /*
    initVcui: function () {
      var self = this;

      //가격 슬라이더
      var uiSlider = self.$layFilter.find(".ui_slider");

      uiSlider.each(function () {
        var $rangeSlider = $(this);
        var suffix = "원";

        $rangeSlider.on(
          "rangesliderinit rangesliderchange rangesliderchanged",
          function (e, data) {
            //console.log(e.type);
            var $rangeSlider = $(e.currentTarget);
            var rangeSlider = $rangeSlider.vcRangeSlider("instance", false);

            var $min = $rangeSlider.siblings(".min");
            var $max = $rangeSlider.siblings(".max");

            var minLabel = data.minValue.title;
            var maxLabel = data.maxValue.title;

            $min.text(minLabel + suffix);
            $max.text(maxLabel + suffix);

            // 이동 중 select() 없이 head 영역 업데이트
            var value = minLabel + "~" + maxLabel;
            $rangeSlider.closest("li").find(".tit_result_content").text(value);

            // 이동 완료 시 1회 발생
            if (e.type === "rangesliderchanged") { // 필터 가격 슬라이더
              if (
                rangeSlider.nowValue.minValue != rangeSlider.originMinValue ||
                rangeSlider.nowValue.maxValue != rangeSlider.originMaxValue
              ) {
                self.removeSelectedData("가격"); // 하나의 값만 필요하므로 선제거
                self.addSelectedData("가격", value);
                $(this).parents(".plp-new-section-product-list").find(".lay-filter-con-plp-inner ul li").remove(".is-num-slider");
                $(this).parents(".plp-new-section-product-list").find(".lay-filter-con-plp-inner ul")
                .prepend(
                  '<li class="is-num-slider"><div class="s-fliter"><span>' +
                  minLabel + "원" + " ~ " + maxLabel + "원" +
                    '</span><button type="button" data-value="' +
                    minLabel + "원" + " ~ " + maxLabel + "원" +
                    '" class="btn-del delete-content"><span class="blind">삭제</span></button></div></li>'
                );
                $(this).parents(".plp-new-section-product-list").find(".lay-filter-con-plp").addClass("active2");
                $(this).parents(".plp-new-section-product-list").find(".lay-filter-con-plp-inner").addClass("on");
                $(this).parents(".plp-new-section-product-list").find("#filterWrap").addClass("is-filter-selected");
              } else {
                self.removeSelectedData("가격", value);
              }

              self.select();
            }
            $(document).on("click", ".is-num-slider .delete-content", function(){
              self.removeSelectedData("가격", value);
            });
          }
        );

        $rangeSlider.vcRangeSlider();
        //$rangeSlider.vcRangeSlider("reset", "1,5");
      });
    },
    */

    /**
     * 필터 헤더 업데이트
     * @param {jQueryElement} target 필터 li
     * @param {array} values 선택 필터 값들
     */
    updateFilterHead: function ($li, values) {
      var self = this;

      var $head = $li.find(".head");
      var $labels = $head.find(".tit_result_content");
      var $count = $head.find(".tit_result_text");

      if (!$li.find(".ui_slider").length) {
        // label
        var labels = !!values.length ? values.slice(0, 2).join(", ") : "";
        $labels.text(labels);

        // count
        $count.text(!!values.length ? values.length : "");
      }
    },

    setFilterParam: function ($input) { 
      var filterId = $input.attributes['id'].value;
      var filterValue = "";
      var filterArray = [];

      if(filterId.indexOf("chk_small_category_") > -1){
        filterArray = filterId.split("_");
        filterValue = "filterSmallCategory_"+filterArray[3];
      }else if(filterId.indexOf("chk_color_") > -1){
        filterValue = "filterColor_"+$input.attributes['value'].value;
      }else if(filterId.indexOf("chk_mltpModelYn") > -1){
        filterValue = "filterMltpModel_Y";
      }else if(filterId.indexOf("chk_lgeMemberFlag") > -1){
        filterValue = "filterMember_Y";
      }else if(filterId.indexOf("chk_tomorrowDeliveryFlag") > -1){
        filterValue = "filterTomorrowDelivery_Y";
      }else if(filterId.indexOf("chk_brand_") > -1){
        filterValue = "filterBrand_"+$input.attributes['data-attr-id'].value+":"+$input.attributes['data-keywd-id'].value+":"+$input.attributes['data-input-mode-code'].value;
      }else if(filterId.indexOf("chk_product_") > -1){
        filterValue = "filterProduct_"+$input.attributes['data-attr-id'].value+":"+$input.attributes['data-keywd-id'].value+":"+$input.attributes['data-input-mode-code'].value;
      }else if(filterId.indexOf("chk_tag_") > -1){
        filterValue = "filterTag_"+$input.attributes['data-attr-id'].value+":"+$input.attributes['data-keywd-id'].value+":"+$input.attributes['data-input-mode-code'].value;
      }else if(filterId.indexOf("chk_setComp_") > -1){
        filterValue = "filterSetComp_"+$input.attributes['data-attr-id'].value+":"+$input.attributes['data-keywd-id'].value;
      }else if(filterId.indexOf("chk_carePromotionBadge") > -1){ // BTOCSITE-63506
		filterValue = "filterCarePromotionBadge_"+$input.attributes['value'].value;
	  }else if(filterId.indexOf("chk_upApplianceFlag") > -1){
		  filterValue = "filterUpApplianceFlag_Y";
	  }
	  
      return filterValue;
    },

    updateFilterUrl: function (values) {

      var self = this;

      self.fliterUrl = "";

      var searchParams = new URLSearchParams(location.search);

      if(searchParams.toString().indexOf("filter") > -1){

          searchParams.delete("filterSmallCategory");
          searchParams.delete("filterColor");
          searchParams.delete("filterMltpModel");
          searchParams.delete("filterMember");
          searchParams.delete("filterTomorrowDelivery");
          searchParams.delete("filterBrand");
          searchParams.delete("filterProduct");
          searchParams.delete("filterTag");
          searchParams.delete("filterSetComp");
		  searchParams.delete("filterCarePromotionBadge");		// BTOCSITE-63506
		  searchParams.delete("filterUpApplianceFlag");

       }

      for(var i = 0; i < values.length; i++){

        var array = values[i].split("_");

        var key = array[0];
        var value = "";
        for(var j = 1; j < array.length; j++){
          if(j == 1){
            value += array[j];
          }else{
            value += "_"+array[j];
          }
        }

        if(i == 0){

          if(searchParams.toString() == ""){

            self.fliterUrl = "?"+key+"="+value;

          }else{

            self.fliterUrl = "&"+key+"="+value;

          }
          
        }else{

          void 0;

          var index = self.fliterUrl.indexOf(key);

          if(index > -1){

            self.fliterUrl = self.fliterUrl.replace(key+"=", key+"="+value+",");

          }else{

            self.fliterUrl += "&"+key+"="+value;

          }
        }
      }

      history.pushState("", "", window.location.pathname + (searchParams.toString() == '' ? '' : '?') + searchParams.toString() + self.fliterUrl);
    },

    /**
     * 태그형 버튼 추가
     * @param {string} filterName 필터 명 // 브랜드 | 유형 | 가격 ...
     * @param {string} value 필터 값 // 얼음정수기 | 900L 이상 | ...
     * @returns
     */
    addTag: function (filterName, value) {
      var self = this;

      self.$bfilterTagList
        .find("ul")
        .append(
          '<li><div class="s-fliter"><span>' +
            value +
            '</span><button type="button" data-contents="' +
            filterName +
            '" data-value="' +
            value +
            '" class="btn-del delete-cotent"><span class="blind">삭제</span></button></div></li>'
        );

        // 20230823 추가
        /*
        self.$bfilterTagList2.find(".clear-all").remove();
        self.$bfilterTagList2
        .find("ul")
        .append(
          '<li class="s-filter-item"><div class="s-fliter"><span>' +
            value +
            '</span><button type="button" data-contents="' +
            filterName +
            '" data-value="' +
            value +
            '" class="btn-del"><span class="blind">삭제</span></button></div></li>' +
            '<li class="clear-all"><button type="button" class="btn-refresh">선택 항목 모두 지우기</button></li>'
        );
        */

      // data-contents="유형" data-value="얼음정수기"
    },

    /**
     * 저장된 필터데이터 토대로 input 상태변경 (현재 UI 상태 무시)
     */
    select: function () {
      var self = this;

      var data = self.selectedData;

      // console.log("!!!!!", data);

      // tag 리스트 비움
      self.$bfilterTagList.find("ul").empty();

      // 20230823 추가
      self.$bfilterTagList2.find("ul").empty();

      // 선택 정보 업데이트
      self.$layFilter
        .find(".ui_filter_accordion li:not('.mo-only'), .top-sort-content")
        .each(function (_, el) {
          var $li = $(el);
          var filterName = $li.find(".tit_result_count").text();
          var values = [];

          // 해당 필터의 값 배열
          if (data && data.hasOwnProperty(filterName)) {
            values = data[filterName].split("||");
          }

          var isSelected;

          // 가격 필터면
          if (!!$li.find(".ui_slider").length) {
            var $rangeSlider = $li.find(".ui_slider");
            var rangeSlider = $rangeSlider.vcRangeSlider("instance", false);

            var label = $li.find(".tit_result_content").text();

            // 선택 데이터에 있는지
            isSelected = values.indexOf(label) > -1;

            var sIdx = isSelected
              ? rangeSlider.nowValue.minValue
              : rangeSlider.originMinValue;
            var eIdx = isSelected
              ? rangeSlider.nowValue.maxValue
              : rangeSlider.originMaxValue;

            // 초기값을 넣던가 선택 데이터 기반으로 상태 변경
            rangeSlider.reset(sIdx + "," + eIdx); //rangesliderinit 발생함

            // if (isSelected) self.addTag(filterName, label);
          } else {
            // 일반
            $li.find("input").each(function (_, el) {
              var $input = $(el);
              var label = $input.next("label").text();

              // 선택 데이터에 있는지
              isSelected = values.indexOf(label) > -1;

              // 상태 변경
              $input.prop("checked", isSelected);

              // tag 재 추가
              // if (isSelected) self.addTag(filterName, label);
            });
          }

          // 필터 헤더 업데이트
          self.updateFilterHead($li, values);
        });

      // 레이아웃 상태 갱신
      self.refreshLayout();
    },

    /**
     * 레이아웃 상태 갱신
     */
    refreshLayout: function () {
      var self = this;

      // 영역 토글
      if (self.$bfilterTagList.find("li").length > 0) {
        self.$bfilterTagList.addClass("on");
      } else {
        self.$bfilterTagList.removeClass("on");
      }

      // 20230823 추가
      if (self.$bfilterTagList2.find("li").length > 0) {
        self.$bfilterTagList2.addClass("on");
      } else {
        self.$bfilterTagList2.removeClass("on");
      }

      // 20230823 추가
      if (self.$bfilterTagList2_1.find("li:not('.clear-all')").length > 0) {
        self.$bfilterTagList2_1.addClass("on");
      } else {
        self.$bfilterTagList2_1.removeClass("on");
      }
    },

    /**
     * bfilter 초기화
     */
    resetBfilter: function () {
      var self = this;
      var uiRangeSliderAll = self.$layFilter.find(".range-wrap-new");

      self.selectedData = {};

      //s:BTOCSITE-55480 초기화 추가
      var isLaptap = $('.KRP0007.isLaptap');
      var laptapListWrap = isLaptap.find('.laptap-opt-list-wrap');
      var laptapList = laptapListWrap.find('.laptap-opt-list');

      if( laptapList.find('.opt-list >li').length > 0 ){
        laptapList.find('.opt-list >li').remove();
        laptapListWrap.hide();


        setTimeout(function(){
          var ui_sticky_h = isLaptap.find('.ui_sticky').height();
          isLaptap.find('.ui_sticky').parent('div').css('height', ui_sticky_h);
        },500)


      }
      //e:BTOCSITE-55480 초기화 추가

      self.select();

      uiRangeSliderAll.each(function(){
       var uiRangeSliderAllItem = $(this).find(".ui_filter_slider");
       var uiRangeSliderAllItemOption = uiRangeSliderAllItem.attr("data-range");
       uiRangeSliderAllItem.vcRangeSlider("reset", uiRangeSliderAllItemOption);
      });

      self.filterValues = []; // 전체 필터 초기화
      self.updateFilterUrl(self.filterValues); // 필터 URL 초기화


      //BTOCSITE-61704 초기화 후에도 스크롤 이동하도록 변경
      viewScrollToProductList();
    },

    /**
     * 선택 데이터 추가
     * @param {string} filterName 필터명
     * @param {string} value 값
     */
    addSelectedData: function (filterName, value, $input) {
      var self = this;

      var data = self.selectedData || {};
      var values = [];

      if (data.hasOwnProperty(filterName)) {
        values = data[filterName].split("||");
      }

      values.push(value);

      self.selectedData = Object.defineProperty(data, filterName, {
        value: values.join("||"),
        configurable: true,
      });

      self.filterValues.push(this.setFilterParam($input));

      this.updateFilterUrl(self.filterValues);
    },

    /**
     * BTOCSITE-55480 노트북 PLP 개선건 - 퀵 필터 영역에 필터영역 선택 속성 추가(20240215)
     *
     */
    addSelectedQuickFilterData :function (filterName, value , input) {
      var _addFilterHtml = '';

      var attrId =  input[0].attributes['data-attr-id'].value;
      var keywdId =  input[0].attributes['data-keywd-id'].value;
      var inputModeCode =  input[0].attributes['data-input-mode-code'] && input[0].attributes['data-input-mode-code'].value !='' ? input[0].attributes['data-input-mode-code'].value : ' ';
      var parentAttrKeywdMngId =  input[0].attributes['data-parent-attr-keywd-mng-id'] && input[0].attributes['data-parent-attr-keywd-mng-id'].value != ''  ? input[0].attributes['data-parent-attr-keywd-mng-id'].value : ' ';
      var fromValue = input[0].attributes['data-from-value'] && input[0].attributes['data-from-value'].value !='' ? input[0].attributes['data-from-value'].value : ' ';
      var toValue =  input[0].attributes['data-to-value'] && input[0].attributes['data-to-value'].value !='' ? input[0].attributes['data-to-value'].value : ' ' ;

      var compareText = '';

      //이미 선택된 데이터 유/무 확인
      if(input[0].attributes['name'] && input[0].attributes['name'].value !='' && input[0].attributes['name'].value.indexOf('product') < 0){
          compareText = $('#quick_'+input[0].attributes['name'].value+'_'+keywdId).text();
      }else{
          compareText = $('#quick_chk_product_'+attrId+'_'+keywdId).text();
      }

      if(compareText.trim() == value.trim()){
        return;
      }

      $('.plp-afilter-inner .choice-base').css({display : 'none'});

      if(value !=''){
        _addFilterHtml += '<li class="swiper-slide swiper-slide-active">';
        _addFilterHtml += '   <button type="button" class="on" ';
        _addFilterHtml +=          'data-type="productFilter"';
        if(input[0].attributes['name'] && input[0].attributes['name'].value !='' && input[0].attributes['name'].value.indexOf('product') < 0){
          _addFilterHtml +=          'id="quick_'+input[0].attributes['name'].value+'_'+keywdId+'"';
        }else{
          _addFilterHtml +=          'id="quick_chk_product_'+attrId+'_'+keywdId+'"';
        }
        _addFilterHtml +=          'data-attr-id ="'+attrId+'"';
        _addFilterHtml +=          'data-keywd-id="'+keywdId+'"';
        _addFilterHtml +=          'data-input-mode-code="'+inputModeCode+'"';
        _addFilterHtml +=          'data-parent-attr-keywd-mng-id ="'+parentAttrKeywdMngId+'"';
        _addFilterHtml +=          'data-from-value="'+fromValue+'"';
        _addFilterHtml +=          'data-to-value="'+toValue+'"';
        _addFilterHtml +=          'data-btn-add-yn="Y"';
        _addFilterHtml +=     '>';
        _addFilterHtml +=         value;
        _addFilterHtml += '   </button>';
        _addFilterHtml += '</li>';

        $('.choice-filter-wrap .swiper-wrapper').prepend(_addFilterHtml);

      }

    },

    /**
     * 선택 데이터 제거
     * @param {string} filterName 필터명
     * @param {string | undefined} value 값, undefined 면 key 제거
     * @returns
     */
    removeSelectedData: function (filterName, value, dataAttribute, $target) {
      var self = this;
      var data = self.selectedData || {};

      if(value && value != '' && dataAttribute !='' && $('#add_quick_chk_product_'+dataAttribute).text() == value){
        $('#quick_chk_product_'+dataAttribute).trigger('click');
      }

      if (data.hasOwnProperty(filterName)) {
        var values = [];

        if (value) {
          var idx = this.filterValues.indexOf(this.setFilterParam($target));
          if (idx > -1) this.filterValues.splice(idx, 1);
          
          this.updateFilterUrl(this.filterValues);

          values = data[filterName].split("||").filter(function (item) {
            return item !== value;
          });
        }

        // values 없으면 key 값 제거 후 중단
        if (!values.length) {
          delete data[filterName];
          return;
        }

        self.selectedData = Object.defineProperty(data, filterName, {
          value: values.join("||"),
          configurable: true,
        });

        void 0;
      }



    },

    /**
     * afilter 노출
     */
    layfilterOpenEv: function() {
      $('.plp-new-section-filter-cont .lay-filter').addClass('active');
      setTimeout(function(){
          $('.plp-new-section-filter-cont .lay-filter-con').addClass('active');
          $(".lay-filter-con-plp-inner").addClass("animated");
      }, 1);
      $("html").addClass("plp-filter-open");
      $(".lay-filter-con-plp").addClass("is-mobile");
    },

    /**
     * afilter 비노출
     */
    layfilterCloseEv: function() {
      $('.plp-new-section-filter-cont .lay-filter-con').removeClass('active');
      $(".lay-filter-con-plp-inner").removeClass("animated");
      setTimeout(function(){
          $('.plp-new-section-filter-cont .lay-filter').removeClass('active');
          $("html").removeClass("plp-filter-open");
          $(".lay-filter-con-plp").removeClass("is-mobile");
          $("body").css({"position":"","width":""});
      }, 200);
    },
  };

  function moFilterTopSortEV() {
    var cont = $('.filter-top-wrap .flex-chk-wrap.top-sort');
    var contItem = cont.find('.chk-wrap');
    if(window.innerWidth < 1024 && contItem.length === 3) {
      cont.addClass('is-triple');
      contItem.removeClass("odd").removeClass("even");
      contItem.each(function(index){
        if(index % 3 == 0) {
            $(this).addClass('is-third');
        }
      });
    }
    else {
      cont.removeClass('is-triple');
      contItem.each(function(index){
        if(index % 2 == 0) {
            $(this).addClass('odd');
        }
        else {
            $(this).addClass('even');
        }
      });
    }
  }

  function careProductFilterSortEV() {
    // BTOCSITE-51881 삭제
    // setTimeout(function(){
    //   var container = $(".list-sorting-outter.is-care-product .list-sorting");
    //   var myPrd = container.find(".own_sortview");
    //   var opt = container.find(".sort-list").innerWidth() + 24;
    //   myPrd.css("right", opt);
    // }, 10);
  }

  function isCareProductCheck() {
    setTimeout(function(){
      $(".list-sorting-outter").not(".is-care-product").find("div").remove(".own_sortview");
    }, 10);
  }

  var last_scrollTop = 0;
  function filterScrollDirectionCheck() {
    var scrFilter = $(".plp-new .cate-wrap").scrollTop();
    if(window.innerWidth < 1024){
      var tmp = $(window).scrollTop();
      if (tmp > last_scrollTop) {
          $(".cate-wrap").removeClass("is-scroll-up");
          $(".cate-wrap").addClass("is-scroll-down");
      } else {
        $(".cate-wrap").removeClass("is-scroll-down");
        $(".cate-wrap").addClass("is-scroll-up");
      }
      last_scrollTop = tmp;
    }
  }

  function userResolutionCheck() {
    if($("body").innerWidth() > 1024) {
      setTimeout(function(){
        var userH = $(window).innerHeight();
        var listH = $("#filterWrap").parent().parent().next().innerHeight();
        if (userH > listH) {
          $(".lay-filter").addClass("is-height-small");
        }
        else {
          $(".lay-filter").removeClass("is-height-small");
        }
      }, 5);
    }
    else {
      $(".lay-filter").removeClass("is-height-small");
    }
  }
  userResolutionCheck();

  $(window).resize(function(){
    if(window.innerWidth > 1023){
      $('.plp-new-section-filter-cont .lay-filter-con').removeClass('active');
      $('.plp-new-section-filter-cont .lay-filter').removeClass('active');
      $("html").removeClass("plp-filter-open");
      $(".cate-wrap").removeClass("is-scroll-down");
      $(".cate-wrap").removeClass("is-scroll-up");
      $(".lay-filter-con-plp").removeClass("is-mobile");
    }
    moFilterTopSortEV();
    careProductFilterSortEV();
    userResolutionCheck();
  });

  $(window).scroll(function() {
    filterScrollDirectionCheck();
    userResolutionCheck();
  });

  moFilterTopSortEV();
  careProductFilterSortEV();
  isCareProductCheck();

  //FilterLayer.init();

  // 서성민 s
  $(document).on('filterLayer.init', function() {
    FilterLayer.init();
  });
  // 서성민 e

  $(document).on('filterMovementEvent.reset', function() {
    filterMovementEvent();
  });

  function filterMovementEvent() {
    if(window.innerWidth > 1024){
      $(".plp-new .lay-filter").each(function(){
        $this = $(this);
        // var scrFilterHei = $(".plp-new .cate-m").outerHeight(true);
        var scrContHei = $this.parent().parent().css("margin-top");
        var scrContHeiInt = parseInt(scrContHei, 10);
        // var scrTarget = $(".plp-new .lay-filter").parent().offset().top - scrFilterHei + scrContHeiInt;
        var scrTarget = $this.parent().offset().top - scrContHeiInt - 30;
        var scrTargetHei = $this.outerHeight(true);
        var scrTargetHei2 = $this.parent().next().outerHeight(true);
        var scrListContHei = $this.parent().next().find(".card-list-content").outerHeight(true);
        var scrListContHei2 = $this.parent().next().find(".product-list-top").outerHeight(true);
        var scrListContHei3 = $this.parent().next().find(".pagination").outerHeight(true);
        var scrTargetCalc1 = scrTargetHei2 - scrTargetHei;
        var scrTargetCalc2 = scrTarget + scrTargetCalc1;
        var scrTargetCalc3 = scrTargetCalc2 - scrListContHei3;
        var scrListContHeiCalc = scrTargetHei2 - scrListContHei - scrListContHei2;
        var scrWindow = $(window).scrollTop();
        var unitLength = $this.parents(".plp-new-section-filter-cont").next(".plp-new-section-list-cont").find(".normal-card").length;
        var unitContainerHeight = $this.parents(".plp-new-section-filter-cont").next(".plp-new-section-list-cont").outerHeight(true);
        var isLongRightArea = scrTargetHei < scrTargetHei2 - scrListContHei3;  // BTOCSITE-56285 오른쪽 영역 짧아질 때 예외 처리

        if(scrTarget < scrWindow && scrWindow < scrTargetCalc3) {
          if(unitLength > 0) {
            $this.removeClass("is-fixed-content-stop");
            $this.addClass("is-fixed-content");
            $this.parent().next().addClass("left-margin");
            $this.css("bottom", '');
            $this.css("max-height", '');
          }
          else {
            $this.removeClass("is-fixed-content");
            $this.removeClass("is-fixed-content-stop");
            $this.parent().next().removeClass("left-margin");
            $this.css("bottom", '');
            $this.css("max-height", unitContainerHeight - scrListContHei3);
          }
        }
        else if(scrWindow > scrTargetCalc3 && isLongRightArea) {
          if(unitLength > 0) {
            $this.removeClass("is-fixed-content");
            $this.addClass("is-fixed-content-stop");
            $this.css("bottom", '');
            $this.css("max-height", '');
          }
          else {
            $this.removeClass("is-fixed-content");
            $this.removeClass("is-fixed-content-stop");
            $this.parent().next().removeClass("left-margin");
            $this.css("bottom", '');
            $this.css("max-height", unitContainerHeight - scrListContHei3);
          }
        }
        else {
          if(unitLength > 0) {
            $this.css("max-height", '');
          }
          else {
            $this.css("max-height", unitContainerHeight - scrListContHei3);
          }
          $this.removeClass("is-fixed-content");
          $this.removeClass("is-fixed-content-stop");
          $this.parent().next().removeClass("left-margin");
          $this.css("bottom", '');
        }
      });
    }
  }
  window.onload = function() {
    filterMovementEvent();
    plpLoadingCheck();
  }
  $(window).on("scroll", function(){
    filterMovementEvent();
  });
  $(document).on("click", ".lay-filter .chk-wrap label", function(){
    setTimeout(function(){
      filterMovementEvent();
      userResolutionCheck();
    }, 1);
  });
  $(document).on("click", ".lay-filter .rdo-wrap label", function(){
    setTimeout(function(){
      filterMovementEvent();
      userResolutionCheck();
    }, 1);
  });
  $(document).on("click", ".lay-filter .chk-wrap-colorchip label", function(){
    setTimeout(function(){
      filterMovementEvent();
      userResolutionCheck();
    }, 1);
  });
  $(document).on("click", ".lay-filter-con-plp .btn-refresh", function(){
    setTimeout(function(){
      filterMovementEvent();
      userResolutionCheck();
    }, 1);
  });

  /*
  function radioCheckedCheck() {
    if($(".lay-filter").find('.rdo-wrap input:radio').is(':checked')) {
    }
    else {
      setTimeout(function(){
        $(".lay-filter").find(".rdo-wrap input:radio").prop("checked", false);
        console.log("asdqwda123321");
      }, 100);
    }
  }
  */

  // 20230823 추가 - BTOCSITE-40437
  $(document).on("change", ".lay-filter .chk-wrap input", function(){
    var filterTitle = $(this).next().text();
    var filterId = $(this).attr("id");
    if ($(this).is(':checked')) {
      $(this).parents(".plp-new-section-product-list").find(".lay-filter-con-plp-inner ul")
      .prepend(
        '<li class="' +
          filterId +
          '"><div class="s-fliter"><span>' +
          filterTitle +
          '</span><button type="button" data-value="' +
          filterTitle +
          '" class="btn-del delete-content"><span class="blind">삭제</span></button></div></li>'
      );
      $(this).parents(".plp-new-section-product-list").find(".lay-filter-con").addClass("is-filter-selected");
      $(this).parents(".plp-new-section-product-list").find(".lay-filter-con-plp-inner").addClass('on');
      $(".lay-filter-con-plp").addClass("active2");
    }
    else {
      $(this).parents(".plp-new-section-product-list").find(".lay-filter-con-plp-inner").find("ul li").remove("." + filterId);
      if($(this).parents(".plp-new-section-product-list").find(".lay-filter-con-plp-inner").find("li").length < 2) {
        $(this).parents(".plp-new-section-product-list").find(".lay-filter-con").removeClass("is-filter-selected");
        $(this).parents(".plp-new-section-product-list").find(".lay-filter-con-plp-inner").removeClass('on');
        $(".lay-filter-con-plp").removeClass("active2");
      }
    }
    // radioCheckedCheck();
  });
  $(document).on("change", ".lay-filter .rdo-wrap input", function(){
    var filterTitle = $(this).next().text();
    var filterId = $(this).attr("name");
    var filterId2 = $(this).attr("id");
    if ($(this).is(':checked')) {
      $(this).parents(".plp-new-section-product-list").find(".lay-filter-con-plp-inner").find("ul li").remove("." + filterId);
      $(this).parents(".plp-new-section-product-list").find(".lay-filter-con-plp-inner ul")
      .prepend(
        '<li class="' +
          filterId +
          '"><div class="s-fliter"><span class="is-radio-type">' +
          filterTitle +
          '</span><button type="button" data-value="' +
          filterTitle +
          '" class="btn-del delete-content"><span class="blind">삭제</span></button><div class="' +
          filterId2 +
          '"></div></div></li>'
      );
      $(this).parents(".plp-new-section-product-list").find(".lay-filter-con").addClass("is-filter-selected");
      $(this).parents(".plp-new-section-product-list").find(".lay-filter-con-plp-inner").addClass('on');
      $(".lay-filter-con-plp").addClass("active2");
    }
    /*
    else {
      $(this).parents(".plp-new-section-product-list").find(".lay-filter-con-plp-inner").find("ul li").remove("." + filterId);
      if($(this).parents(".plp-new-section-product-list").find(".lay-filter-con-plp-inner").find("li").length < 2) {
        $(this).parents(".plp-new-section-product-list").find(".lay-filter-con").removeClass("is-filter-selected");
        $(".lay-filter-con-plp").removeClass("active2");
      }
    }
    */
  });
  $(document).on("change", ".lay-filter .chk-wrap-colorchip input", function(){
    var filterTitle = $(this).next().text();
    var filterId = $(this).attr("id");
    if ($(this).is(':checked')) {
      $(this).parents(".plp-new-section-product-list").find(".lay-filter-con-plp-inner ul")
      .prepend(
        '<li class="' +
          filterId +
          '"><div class="s-fliter"><span>' +
          filterTitle +
          '</span><button type="button" data-value="' +
          filterTitle +
          '" class="btn-del delete-content"><span class="blind">삭제</span></button></div></li>'
      );
      $(this).parents(".plp-new-section-product-list").find(".lay-filter-con").addClass("is-filter-selected");
      $(this).parents(".plp-new-section-product-list").find(".lay-filter-con-plp-inner").addClass('on');
      $(".lay-filter-con-plp").addClass("active2");
    }
    else {
      $(this).parents(".plp-new-section-product-list").find(".lay-filter-con-plp-inner").find("ul li").remove("." + filterId);
      if($(this).parents(".plp-new-section-product-list").find(".lay-filter-con-plp-inner").find("li").length < 2) {
        $(this).parents(".plp-new-section-product-list").find(".lay-filter-con").removeClass("is-filter-selected");
        $(this).parents(".plp-new-section-product-list").find(".lay-filter-con-plp-inner").removeClass('on');
        $(".lay-filter-con-plp").removeClass("active2");
      }
    }
  });
  $(document).on("click", ".plp-new-section-product-list .btn-refresh", function(){
    $(".filter-item-type-sort input").prop("checked", false);
    if($(this).parents(".plp-new-section-product-list").find(".lay-filter-con-plp-inner").find("li").length < 2) {
      $(this).parents(".plp-new-section-product-list").find(".lay-filter-con").removeClass("is-filter-selected");
      $(this).parents(".plp-new-section-product-list").find(".lay-filter-con-plp-inner").removeClass("on");
      $(".lay-filter-con-plp").removeClass("active2");
    }
  });

  function plpGridChangeEv() {
    var listBt1 = $('.grid-change-bt');
    var listContent1 = $('.plp-new-section-list-cont');
      if (listContent1.hasClass('list-type')) {
          listContent1.removeClass('list-type').addClass('twin-type');
          listBt1.removeClass('list-type').addClass('twin-type');
		  $('.card-list-item.list-small-banner').hide();
          void 0;
      }
      else if (listContent1.hasClass('twin-type')) {
          listContent1.removeClass('twin-type').addClass('list-type');
          listBt1.removeClass('twin-type').addClass('list-type');
		  $('.card-list-item.list-small-banner').show();
          void 0;
      }

    listItemSizeCheck(); // BTOCSITE-65817 [PLP] 제품명과 모델영문명 겹침현상
  };
  /*
  function plpListResize() {
    if ($("body").innerWidth() > 768 && $("body").innerWidth() < 770) {
      $('.grid-change-bt').removeClass('twin-type').addClass('list-type');
      $('.plp-new-section-list-cont').removeClass('twin-type').addClass('list-type');
      console.log("is-change-grid");
    }
  };
  */
  function resizeSlide() {
    if(window.innerWidth == 1025) {
      $(".lay-filter").find(".range-wrap-new").each(function(){
        var slideContent = $(this).find(".ui_filter_slider");
        var slideContentOption = slideContent.attr("data-range");
        slideContent.vcRangeSlider("update", true);;
      });
    }
  }
  // plpListResize();
  $(document).on("click", ".grid-change-cont", function(){
      plpGridChangeEv();
  });
  $(window).resize(function(){
      // plpListResize();
      resizeSlide();
  });
  $(document).on("click", ".list-count-mobile-inner .ui-select-button", function(){
    var target = $(this).parents(".ui-selectbox-wrap");
    var target2 = target.find(".ui-selectbox-list");
    if(target2.hasClass("active")) {
      target.removeClass("on");
      target2.removeClass("active");
    }
    else {
      target.addClass("on");
      target2.addClass("active");
    }
  });
  $(document).on("click", ".list-count-mobile-inner .ui-select-scrollarea li a", function(){
    var target = $(this).parents(".ui-selectbox-wrap");
    var target2 = target.find(".ui-selectbox-list");
    var target3 = target.find(".ui-select-text");
    var target4 = $(this).text();
    var target5 = $(this).parent();
    if(target2.hasClass("active")) {
      target.removeClass("on");
      target2.removeClass("active");
      target2.find("li").removeClass("on");
      target5.addClass("on");
    }
    else {
      target.addClass("on");
      target2.addClass("active");
    }
    target3.text(target4);
  });

  $(document).on("click", ".lay-filter", function(){
    userResolutionCheck();
    void 0;
  });
  $(document).on("click", ".cate-wrap", function(){
    userResolutionCheck();
    void 0;
  });
  $(document).on("click", ".search-wrap", function(){
    userResolutionCheck();
    void 0;
  });

  var offsetPosA = 0;
  $(window).resize(function(){
    offsetPosA = $(".plp-new-section-product-list").offset();
  });
  function viewScrollToProductList() { // 제품 리스트로 화면 스크롤 이동하는 이벤트
      var offsetPos = $(".cate-m").offset();
	  var subRenewMainWrap = $('.subRenewMainWrap');
	  var subRenewMainWrapHeader = subRenewMainWrap.find('.header');
	  var subRenewWrap = $('.subRenewWrap');
	  var subRenewWrapHeader = subRenewWrap.find('.header');
	  var subRenewWrapNav = subRenewWrap.find('.sub-renew-nav-wrap');
	  
	  $('html').animate({scrollTop : offsetPos.top}, 400, function(){
		subRenewMainWrapHeader.addClass('hide');
		subRenewWrapHeader.addClass('hide');
		subRenewWrapNav.addClass('hide');
	  });	  
  }
  // viewScrollToProductList();

  $(document).on("click", ".card-list-none-button", function (e) {
    $(".btn-refresh").trigger("click");
    viewScrollToProductList();
  });
  $(document).on("click", ".btn-moveto-product", function (e) {
    $(".filter-close .btn-close").trigger("click");
    viewScrollToProductList();
  });

  $(document).on("click", ".ui-toggle-filter-new", function(e){
    e.preventDefault();
    var accoTarget = $(this).parent().parent();
    if(accoTarget.find(".head").hasClass("btn_open")) {
      accoTarget.find(".head").removeClass("btn_open");
      accoTarget.find(".head").addClass("btn_close");
      accoTarget.find(".ui_accord_content").slideDown(300);
      accoTarget.find(".ui_accord_text").text("내용 더 보기");
      $(this).attr("aria-expanded", true);
    }
    else if(accoTarget.find(".head").hasClass("btn_close")) {
      accoTarget.find(".head").removeClass("btn_close");
      accoTarget.find(".head").addClass("btn_open");
      accoTarget.find(".ui_accord_content").slideUp(300);
      accoTarget.find(".ui_accord_text").text("내용 닫기");
      $(this).attr("aria-expanded", false);
    }
  });

  function listItemSizeCheck() {
      $('.product-card-list .card-list-item').removeClass("first");
      $('.product-card-list .card-list-item').removeClass("second");
      $('.product-card-list .card-list-item').removeClass("third");
      $(".item-top-badge").css("height", "");
      $(".top-title-main").css("height", "");
      $(".item-middle-prdtype").css("height", "");
      $(".item-timedeal").css("height", "");
      $(".middle-info-inner").css("height", "");
      if($("body").innerWidth() > 1380) {
          $('.product-card-list .card-list-item').each(function(index){
              if(index % 3 == 0) {
                  $(this).addClass('first');
              }
              else if(index % 3 == 1) {
                  $(this).addClass('second');
              }
              else {
                  $(this).addClass('third');
              }

              setTimeout(function(){
                  $('.product-card-list .card-list-item.second').each(function(index) {
                      var size1_01 = $(this).prev(".first").find(".item-top-badge");
                      var size2_01 = $(this).find(".item-top-badge");
                      var size3_01 = $(this).next(".third").find(".item-top-badge");
                      var size1_01Val = size1_01.outerHeight();
                      var size2_01Val = size2_01.outerHeight();
                      var size3_01Val = size3_01.outerHeight();
                      var maxVal01 = Math.max(size1_01Val, size2_01Val, size3_01Val);

                      var size1_02 = $(this).prev(".first").find(".top-title-main");
                      var size2_02 = $(this).find(".top-title-main");
                      var size3_02 = $(this).next(".third").find(".top-title-main");
                      var size1_02Val = size1_02.outerHeight();
                      var size2_02Val = size2_02.outerHeight();
                      var size3_02Val = size3_02.outerHeight();
                      var maxVal02 = Math.max(size1_02Val, size2_02Val, size3_02Val);

                      var size1_03 = $(this).prev(".first").find(".item-middle-prdtype");
                      var size2_03 = $(this).find(".item-middle-prdtype");
                      var size3_03 = $(this).next(".third").find(".item-middle-prdtype");
                      var size1_03Val = size1_03.outerHeight();
                      var size2_03Val = size2_03.outerHeight();
                      var size3_03Val = size3_03.outerHeight();
                      var maxVal03 = Math.max(size1_03Val, size2_03Val, size3_03Val);

                      var size1_04 = $(this).prev(".first").find(".item-timedeal");
                      var size2_04 = $(this).find(".item-timedeal");
                      var size3_04 = $(this).next(".third").find(".item-timedeal");
                      var size1_04Val = size1_04.outerHeight();
                      var size2_04Val = size2_04.outerHeight();
                      var size3_04Val = size3_04.outerHeight();
                      var maxVal04 = Math.max(size1_04Val, size2_04Val, size3_04Val);

                      var size1_05 = $(this).prev(".first").find(".middle-info-inner");
                      var size2_05 = $(this).find(".middle-info-inner");
                      var size3_05 = $(this).next(".third").find(".middle-info-inner");
                      var size1_05Val = size1_05.outerHeight();
                      var size2_05Val = size2_05.outerHeight();
                      var size3_05Val = size3_05.outerHeight();
                      var maxVal05 = Math.max(size1_05Val, size2_05Val, size3_05Val);

                      // 유닛 최상단 뱃지
                      size1_01.css("height", maxVal01);
                      size2_01.css("height", maxVal01);
                      size3_01.css("height", maxVal01);

                      // 유닛 메인 타이틀
                      size1_02.css("height", maxVal02);
                      size2_02.css("height", maxVal02);
                      size3_02.css("height", maxVal02);

                      // 유닛 제품 타입 선택
                      size1_03.css("height", maxVal03);
                      size2_03.css("height", maxVal03);
                      size3_03.css("height", maxVal03);
                      
                      // 유닛 타임딜 영역
                      size1_04.css("height", maxVal04);
                      size2_04.css("height", maxVal04);
                      size3_04.css("height", maxVal04);
                      
                      // 유닛 스펙 영역
                      size1_05.css("height", maxVal05);
                      size2_05.css("height", maxVal05);
                      size3_05.css("height", maxVal05);
                  });
              }, 10);
          });
      } else if($("body").innerWidth() < 1381 && $("body").innerWidth() > 767) {
          /*
          $('.plp-new-section-list-cont').removeClass('twin-type').addClass('list-type');
          $('.grid-change-bt').removeClass('twin-type').addClass('list-type');
          $(".grid-change-bt").find(".twin-ico").removeClass("active");
          $(".grid-change-bt").find(".list-ico").addClass("active");
          */
          $('.product-card-list .card-list-item').each(function(index){
              if(index % 2 == 0) {
                  $(this).addClass('first');
              }
              else {
                  $(this).addClass('second');
              }

              setTimeout(function(){
                  $('.product-card-list .card-list-item.second').each(function(index) {
                      var size1_01 = $(this).prev(".first").find(".item-top-badge");
                      var size2_01 = $(this).find(".item-top-badge");
                      var size1_01Val = size1_01.outerHeight();
                      var size2_01Val = size2_01.outerHeight();
                      var maxVal01 = Math.max(size1_01Val, size2_01Val);

                      var size1_02 = $(this).prev(".first").find(".top-title-main");
                      var size2_02 = $(this).find(".top-title-main");
                      var size1_02Val = size1_02.outerHeight();
                      var size2_02Val = size2_02.outerHeight();
                      var maxVal02 = Math.max(size1_02Val, size2_02Val);

                      var size1_03 = $(this).prev(".first").find(".item-middle-prdtype");
                      var size2_03 = $(this).find(".item-middle-prdtype");
                      var size1_03Val = size1_03.outerHeight();
                      var size2_03Val = size2_03.outerHeight();
                      var maxVal03 = Math.max(size1_03Val, size2_03Val);

                      var size1_04 = $(this).prev(".first").find(".item-timedeal");
                      var size2_04 = $(this).find(".item-timedeal");
                      var size1_04Val = size1_04.outerHeight();
                      var size2_04Val = size2_04.outerHeight();
                      var maxVal04 = Math.max(size1_04Val, size2_04Val);

                      var size1_05 = $(this).prev(".first").find(".middle-info-inner");
                      var size2_05 = $(this).find(".middle-info-inner");
                      var size1_05Val = size1_05.outerHeight();
                      var size2_05Val = size2_05.outerHeight();
                      var maxVal05 = Math.max(size1_05Val, size2_05Val);

                      // 유닛 최상단 뱃지
                      size1_01.css("height", maxVal01);
                      size2_01.css("height", maxVal01);

                      // 유닛 메인 타이틀
                      size1_02.css("height", maxVal02);
                      size2_02.css("height", maxVal02);

                      // 유닛 제품 타입 선택
                      size1_03.css("height", maxVal03);
                      size2_03.css("height", maxVal03);
                      
                      // 유닛 타임딜 영역
                      size1_04.css("height", maxVal04);
                      size2_04.css("height", maxVal04);
                      
                      // 유닛 스펙 영역
                      size1_05.css("height", maxVal05);
                      size2_05.css("height", maxVal05);
                  });
              }, 10);
          });
      } else if($("body").innerWidth() < 768 && $(".grid-change-bt").hasClass("twin-type")) {
        $('.product-card-list .card-list-item.normal-card').each(function(index){
          if(index % 2 == 0) {
            $(this).addClass('first');
          }
          else {
            $(this).addClass('second');
          }
  
          setTimeout(function(){
            $('.product-card-list .card-list-item.second').each(function(index) {
              var size1_01 = $(this).prev(".first").find(".item-top-badge");
              var size2_01 = $(this).find(".item-top-badge");
              var size3_01 = $(this).prev(".list-small-banner").prev(".first").find(".item-top-badge");
              var size1_01Val = size1_01.outerHeight();
              var size2_01Val = size2_01.outerHeight();
              var size3_01Val = size3_01.outerHeight();
              var maxVal01 = Math.max(size1_01Val, size2_01Val, size3_01Val);
  
              var size1_02 = $(this).prev(".first").find(".top-title-main");
              var size2_02 = $(this).find(".top-title-main");
              var size3_02 = $(this).prev(".list-small-banner").prev(".first").find(".top-title-main");
              var size1_02Val = size1_02.outerHeight();
              var size2_02Val = size2_02.outerHeight();
              var size3_02Val = size3_02.outerHeight();
              var maxVal02 = Math.max(size1_02Val, size2_02Val, size3_02Val);
  
              var size1_03 = $(this).prev(".first").find(".item-middle-prdtype");
              var size2_03 = $(this).find(".item-middle-prdtype");
              var size3_03 = $(this).prev(".list-small-banner").prev(".first").find(".item-middle-prdtype");
              var size1_03Val = size1_03.outerHeight();
              var size2_03Val = size2_03.outerHeight();
              var size3_03Val = size3_03.outerHeight();
              var maxVal03 = Math.max(size1_03Val, size2_03Val, size3_03Val);
  
              var size1_04 = $(this).prev(".first").find(".item-timedeal");
              var size2_04 = $(this).find(".item-timedeal");
              var size3_04 = $(this).prev(".list-small-banner").prev(".first").find(".item-timedeal");
              var size1_04Val = size1_04.outerHeight();
              var size2_04Val = size2_04.outerHeight();
              var size3_04Val = size3_04.outerHeight();
              var maxVal04 = Math.max(size1_04Val, size2_04Val, size3_04Val);
  
              var size1_05 = $(this).prev(".first").find(".middle-info-inner");
              var size2_05 = $(this).find(".middle-info-inner");
              var size3_05 = $(this).prev(".list-small-banner").prev(".first").find(".middle-info-inner");
              var size4_05 = $(this).next(".first");
              var size1_05Val = size1_05.outerHeight();
              var size2_05Val = size2_05.outerHeight();
              var size3_05Val = size3_05.outerHeight();
              var maxVal05 = Math.max(size1_05Val, size2_05Val, size3_05Val);
  
              // 유닛 최상단 뱃지
              size1_01.css("height", maxVal01);
              size2_01.css("height", maxVal01);
              size3_01.css("height", maxVal01);
  
              // 유닛 메인 타이틀
              size1_02.css("height", maxVal02);
              size2_02.css("height", maxVal02);
              size3_02.css("height", maxVal02);
  
              // 유닛 제품 타입 선택
              size1_03.css("height", maxVal03);
              size2_03.css("height", maxVal03);
              size3_03.css("height", maxVal03);
  
              // 유닛 타임딜 영역
              size1_04.css("height", maxVal04);
              size2_04.css("height", maxVal04);
              size3_04.css("height", maxVal04);
  
              // 유닛 스펙 영역
              size1_05.css("height", maxVal05);
              size2_05.css("height", maxVal05);
              size3_05.css("height", maxVal05);
              
              if( maxVal05 == 0 ) {
                size1_05.parent('.item-middle-info').css('padding', '0');
                size2_05.parent('.item-middle-info').css('padding', '0');
                size3_05.parent('.item-middle-info').css('padding', '0');
              }
  
              if( size1_05.find('li').length == 0 ) {
                size1_05.parent('.item-middle-info').css('background', '#fff');
              } else if( size2_05.find('li').length == 0 ) {
                size2_05.parent('.item-middle-info').css('background', '#fff');
              } else if( size3_05.find('li').length == 0 ) {
                size3_05.parent('.item-middle-info').css('background', '#fff');
              }
  
              if( size4_05.next(".second") ) {
                if( size4_05.find('.middle-info-inner li').length == 0 ) {
                  size4_05.find('.middle-info-inner').parent('.item-middle-info').css('padding', '0');
                }
              }
            });
          }, 10);
        });
        
        if( $('.product-card-list .card-list-item.normal-card .middle-info-inner li').length == 0 ) {
          $('.product-card-list .card-list-item.normal-card .middle-info-inner').parent('.item-middle-info').css('padding', '0');
        }
    }
  }

  $(document).on("click", ".lay-filter-con-plp .s-filter-list li .ui-select-button", function(){
    setTimeout(function(){
        listItemSizeCheck();
    }, 10);
  });
  listItemSizeCheck();

  function cabinetSlideBtnHide2() {
    var thumbList = $('.plp-new .fixed-tab-wrap .ui_smooth_tab .tabs');
    var thumbListWrap = thumbList.parent();
    if( thumbList.closest('.cate-m.cate-m-tab.mo-only').hasClass('expanded') == false){
      if(thumbList.width() > thumbListWrap.width()) {
          thumbListWrap.parents('.cate-list').find(".btn-expand").show();
      } else if(thumbList.width() < thumbListWrap.width()) {
        thumbListWrap.parents('.cate-list').find(".btn-expand").hide();
      }
    }
  }
  cabinetSlideBtnHide2();
  $(window).on("resize", function(){
    cabinetSlideBtnHide2();
  });

  $(document).on("click", ".close-new-plp", function(){
    $(".plp-filter-wrap .filter-close .btn-close").trigger("click");
  });

  $(document).on("click", ".afilter-btn-area .btn-afilter", function(){
	$("body").css({"position":"fixed","width":"100%"});
  });

/*
  function alertLoginPopupEV1() {
    var popup = $(".plp-new-alert-popup.popup1");
    popup.addClass("active");
  }
  function alertLoginPopupEV2() {
    var popup = $(".plp-new-alert-popup.popup2");
    popup.addClass("active");
  }
  function alertLoginPopupEV3() {
    var popup = $(".plp-new-alert-popup.popup3");
    popup.addClass("active");
  }
  $(document).on("click", ".is-business-price .is-business-price-popup", function(e){
    e.preventDefault();
    alertLoginPopupEV1();
    alertLoginPopupEV2();
    alertLoginPopupEV3();
  });
  $(document).on("click", ".plp-new-alert-popup .is-dim", function(){
    $(this).parents(".plp-new-alert-popup").removeClass("active");
  });
  $(document).on("click", ".plp-new-alert-popup button", function(){
    $(this).parents(".plp-new-alert-popup").removeClass("active");
  });
*/
  function plpLoadingCheck() {
		$(".plp-new-section").removeClass("is-loading");
		$(".plp-new-section").removeClass("length2");
		$(".plp-new-section").removeClass("length3");
		$(".plp-new-section").removeClass("length4");
		$("body").removeClass("is-loading");
	}

  // 퍼블 페이지용 스크립트 - 개발 작업 후 운영 넘어간 뒤로 퍼블 페이지에 한해서 스와이퍼 혹은 배경 제어용 스크립트가 작동하지 않아 재작업 진행 
  function isPlpPubEv1() {
    if ($('.plp-pub').length) {
      if ($('.main-banner-inner .swiper-slide').length) {
        if ($('.main-banner-inner .swiper-wrapper').children().length > 1) {
          // var plpMainBannerTopSwiper = new Swiper(".main-banner-inner", {
          var plpMainBannerTopSwiper = new Swiper(".main-banner-inner", {
            slidesPerView: 'auto', // 한 슬라이드에 보여줄 갯수
            centeredSlides: false,    //센터모드
            loop: true,   // 슬라이드 반복 여부
            loopAdditionalSlides: 1,
            autoplay: true,
            autoplaySpeed: 5000,
            pagination: {
              el: '.main-banner-inner .plp-category-navi',
              clickable: true,
              type: 'bullets',
            },
          });
        }
      }
    }
  }
  function isPlpPubEv2() {
    if ($('.plp-pub').length) {
      if ($('.plp-main-banner-swiper .swiper-slide').length) {
        // var swiperTopNum = $('.plp-main-banner-swiper').find('.swiper-slide');
        // var swiperSubNum = $('.plp-main-banner-sub-swiper').find('.plp-main-banner-sub-swiper');
        // var plpMainBannerSwiper = new Swiper(".plp-main-banner-swiper", {
        var plpMainBannerSwiperOptions = {
          slidesPerView: 'auto',
          loopAdditionalSlides: 1,
          autoHeight: false,
          autoplaySpeed: 5000,
          navigation: {
            nextEl: '.plp-main-banner-swiper-outer .carousel-navi-type-arrow.pc .sel-right', // 다음 버튼 클래스명
            prevEl: '.plp-main-banner-swiper-outer .carousel-navi-type-arrow.pc .sel-left', // 이번 버튼 클래스명
          },
          pagination: {
            el: '.plp-main-banner-swiper-outer .plp-category-navi',
            clickable: true,
            type: 'bullets',
          },
          breakpoints: {
            1024: {
              slidesPerView: 2,
              spaceBetween: 32,
            },
          },
        };

        if ($(window).width() >= 1024 && $('.plp-main-banner-swiper .swiper-wrapper').children().length > 2) {
          $('.plp-main-banner-swiper').parent().addClass('is-swipe');
          plpMainBannerSwiperOptions.loop = true;
          plpMainBannerSwiperOptions.autoplay = true;
          plpMainBannerSwiperOptions.navigation.nextEl = '.plp-main-banner-swiper-outer .carousel-navi-type-arrow.pc .sel-right';
          plpMainBannerSwiperOptions.navigation.prevEl = '.plp-main-banner-swiper-outer .carousel-navi-type-arrow.pc .sel-left';
        } else if ($(window).width() < 1024 && $('.plp-main-banner-swiper .swiper-wrapper').children().length > 1) {
            plpMainBannerSwiperOptions.loop = true;
            plpMainBannerSwiperOptions.autoplay = true;
        }

        if ($('.plp-main-banner-swiper .swiper-wrapper').children().length > 1) {
            var plpMainBannerSwiper = new Swiper(".plp-main-banner-swiper", plpMainBannerSwiperOptions);
        } else {
            $('.plp-main-banner-swiper').parent().addClass('is-single');
        }
      }
    }
  }
  function isPlpPubEv3() {
    if ($('.plp-pub').length) {
      if ($('.pc .plp-category-swiper').length) {
        if ($('.pc .plp-category-swiper .swiper-wrapper').children().length > 1) {
            if($(".pc .plp-category-swiper").find(".swiper-slide").length == 2) {
                $(".plp-new-section.category-list.pc").addClass("length2");
            }
            else if($(".pc .plp-category-swiper").find(".swiper-slide").length == 3) {
                $(".plp-new-section.category-list.pc").addClass("length3");
            }
            else if($(".pc .plp-category-swiper").find(".swiper-slide").length == 4) {
                $(".plp-new-section.category-list.pc").addClass("length4");
            }
            // var plpNewBannerSwiper1_1 = new Swiper(".pc .plp-category-swiper", {
              var plpNewBannerSwiper1_1 = new Swiper(".pc .plp-category-swiper", {
                slidesPerView: 'auto',
                spaceBetween: 10,
                centeredSlides: false,    //센터모드
                loop: false,   // 슬라이드 반복 여부
                loopAdditionalSlides: 1,
                /*
                pagination: {
                    el: '.category-list.pc .plp-category-navi',
                    clickable: true,
                    type: 'bullets',
                },
                */
                breakpoints: {
                    1024: {
                        spaceBetween: 33,    // 슬라이드 사이 여백
                        slidesPerView: 5, // 한 슬라이드에 보여줄 갯수
                    },
                },
                navigation: {
                    nextEl: '.category-list.pc .carousel-navi-type-arrow.pc .sel-right', // 다음 버튼 클래스명
                    prevEl: '.category-list.pc .carousel-navi-type-arrow.pc .sel-left', // 이번 버튼 클래스명
                },
            });
        }
        else {
            $('.pc .plp-category-swiper').parent().addClass('is-single');
        }
      }
    }
  }


  function isPlpPubEv3_1() {
    if ($('.plp-pub').length) {
      if (window.innerWidth > 1024) {
          // var mainHei1 = $(".plp-main-banner-swiper .swiper-slide").innerHeight() / 2;
          var mainHei1 = $(".plp-main-banner-swiper .swiper-slide .swiper-top").innerHeight() / 2;
          $(".main-banner-swiper .carousel-navi-type-arrow.pc").css('top', mainHei1);
      }
      if (window.innerWidth > 1024) {
          var mainHei2 = $(".plp-category-swiper .img-container").innerHeight() / 2;
          $(".category-list.pc .carousel-navi-type-arrow.pc").css('top', mainHei2);
      }

    }
  }
  function isPlpPubEv4() {
    if ($('.plp-pub').length) {
      if ($('.plp-small-banner-swiper .swiper-slide').length) {
          if ($('.plp-small-banner-swiper .swiper-wrapper').children().length > 1) {
              // var plpNewBannerSwiper1_1 = new Swiper(".plp-small-banner-swiper-inner", {
                var plpNewBannerSwiper1_1 = new Swiper(".plp-small-banner-swiper-inner", {
                  spaceBetween: 10,    // 슬라이드 사이 여백
                  slidesPerView: 'auto', // 한 슬라이드에 보여줄 갯수
                  centeredSlides: false,    //센터모드
                  loop: false,   // 슬라이드 반복 여부
                  loopAdditionalSlides: 1,
                  navigation: {
                      nextEl: '.small-banner-swiper-arrow .right', // 다음 버튼 클래스명
                      prevEl: '.small-banner-swiper-arrow .left', // 이번 버튼 클래스명
                  },
              });
          } else {
              $('.plp-small-banner-swiper').parent().addClass('is-single');
          }
      }
    }
  }
  function isPlpPubEv5() {
    if ($('.plp-pub').length) {
      if ($('.plp-small-banner-card-swiper .swiper-slide').length) {
          if ($('.plp-small-banner-card-swiper .swiper-wrapper').children().length > 1) {
              // var plpNewBannerSwiper1_2 = new Swiper(".plp-small-banner-card-swiper-inner", {
              var plpNewBannerSwiper1_2 = new Swiper(".plp-small-banner-card-swiper-inner", {
                  spaceBetween: 16,    // 슬라이드 사이 여백
                  slidesPerView: 'auto', // 한 슬라이드에 보여줄 갯수
                  centeredSlides: false,    //센터모드
                  loop: false,   // 슬라이드 반복 여부
                  loopAdditionalSlides: 1,
                  breakpoints: {
                      1024: {
                          slidesPerView: 2,
                          spaceBetween: 32,
                      },
                  },
                  pagination: {
                      el: '.plp-small-banner-card-swiper .plp-category-navi',
                      clickable: true,
                      type: 'bullets',
                  },
              });
          } else {
              $('.plp-small-banner-card-swiper').parent().addClass('is-single');
          }
      }
    }
  }
  function isPlpPubEv6() {
    if ($('.plp-pub').length) {
      if ($('.best-tab-manu .swiper-slide').length) {
          // var plpBestTab = new Swiper(".best-tab-manu", {
          var plpBestTab = new Swiper(".best-tab-manu", {
              spaceBetween: 4,    // 슬라이드 사이 여백
              slidesPerView: 'auto', // 한 슬라이드에 보여줄 갯수
              centeredSlides: false,    //센터모드
              loop: false,   // 슬라이드 반복 여부
              loopAdditionalSlides: 1,
              breakpoints: {
                  1024: {
                      spaceBetween: 8,
                  },
              },
          });
      }
    }
  }
  function isPlpPubEv7() {
    if ($('.plp-pub').length) {
      if ($('.main-banner-tab-manu .swiper-slide').length) {
          // var plpMainTab = new Swiper(".main-banner-tab-manu", {
          var plpMainTab = new Swiper(".main-banner-tab-manu", {
              spaceBetween: 8,    // 슬라이드 사이 여백
              slidesPerView: 'auto', // 한 슬라이드에 보여줄 갯수
              centeredSlides: false,    //센터모드
              loop: false,   // 슬라이드 반복 여부
              loopAdditionalSlides: 1,
          });
      }
    }
  }
  function isPlpPubEv8() {
    if ($('.plp-pub').length) {
      var mathWid = $('.main-banner-tab-background').outerWidth();
      var resizingWid = $('.main-banner-tab-background img').outerWidth();
      var mathHei = $('.main-banner-tab-background').outerHeight();
      var resizingHei = $('.main-banner-tab-background img').outerHeight();
      if (mathHei > resizingHei) {
          $('.main-banner-tab-background').removeClass('resize-w').addClass('resize-h');
      } else if (mathHei < resizingHei) {
          $('.main-banner-tab-background').removeClass('resize-h').addClass('resize-w');
      } else if (mathWid > resizingWid) {
          $('.main-banner-tab-background').removeClass('resize-h').addClass('resize-w');
      } else if (mathWid < resizingWid) {
          $('.main-banner-tab-background').removeClass('resize-w').addClass('resize-h');
      }
    }
  }
  isPlpPubEv1();
  isPlpPubEv2();
  isPlpPubEv3();
  isPlpPubEv4();
  isPlpPubEv5();
  isPlpPubEv6();
  isPlpPubEv7();
  isPlpPubEv8();
  isPlpPubEv3_1();
  $(window).resize(function(){
    isPlpPubEv8();
    isPlpPubEv3_1();
  });
})();

$(function(){
  function headerHelloBarCheck() {
    setTimeout(function(){
      if($(".header").hasClass("helloBar")){
        $(".plp-new").addClass("is-have-hellobar");
      } else {
        $(".plp-new").removeClass("is-have-hellobar");
      }
    }, 50);
  }
  $(document).on("click", ".hello-bar-wrap .close", function(){
    $(".plp-new").removeClass("is-have-hellobar");
  }); 
  headerHelloBarCheck();
  $(document).on("click", ".mobile-nav-wrap .nav-item", function(){
    var $this = $(this);
    if(!$(".header").hasClass("hide")){
      setTimeout(function(){
        if(!$this.hasClass("on")){
          $(".plp-new .cate-wrap").addClass("top-extand");
        }
      }, 20);
    }
  });
  $(document).on("click", ".sub-renew-dimmed", function(){
      var $this = $(this);
      if(!$(".header").hasClass("hide")){
       setTimeout(function(){
         if(!$this.hasClass("on")){
             $(".plp-new .cate-wrap").addClass("top-extand");
         }
       }, 20);
      }
  });

  $('.max-reward').on('click', function(e) {
    e.preventDefault();
    // KRP0007-3.0.0.js   > $unitList.on('click', '.max-reward', function(e) {.... 스크립트 중복으로 삭제(20240625)
    //$('#maximumBenefitPricePopup').vcModal("show");
  });
  $(document).on('click', '#maximumBenefitPricePopup .ui_modal_close, maxBenefitRentalPop .ui_modal_close', function(){
    $('#maximumBenefitPricePopup, #maxBenefitRentalPop').vcModal("hide");
  });

  $(document).on('click', '.rental-max-reward', function(e) {
    e.preventDefault();

    // 모바일, 요약형은 팝업 호출 안함
    if (vcui.detect.isMobileDevice && $('.list-count-mobile button.grid-change-bt').hasClass('twin-type')) {
      return;
    }

    var target = $(this);
    var sellingPrice = target.data('selling-price') || 0;
    var partnerPrice = target.data('partner-price') || 0;
    var rentalCareMaxSalePrice = target.data('rental-care-max-sale-price') || 0;
    var partnerGrp = target.data('partner-grp') || '';

    // BTOCSITE-64163, [구독 Task] Sales - 재구독
    var reorderPrice = target.data('reorder-price') || 0;
    var reorderFlag = target.data('reorder-flag') || 0;

    // BTOCSITE-73594 [개발] [구독] 가전 연계 구독 할인
    var linkOrderPrice = target.data('link-order-price') || 0;
    var linkOrderFlag = target.data('link-order-flag') || 0;
	
	// 임직원/복지몰 할인가가 일반가보다 높으면 팝업 노출 안함
	if (partnerPrice > 0 && partnerPrice > sellingPrice) {
		return;
	}

    var finalSellingPrice = sellingPrice;

    $('#maxBenefitRentalPop header.pop-header h4.tit span').text('최대혜택가');
    $('#maxBenefitRentalPop div.price span.won').html('월 ' + vcui.number.addComma(sellingPrice) + '원');
    $('#maxBenefitRentalPop #maxBenefitRentalNoReorderMsg').hide();
    
    var discountArea = $('#maxBenefitRentalPop ul.discount-price');
    discountArea.empty();

    if ((partnerGrp === 'LGE' || partnerGrp === 'AFF' || partnerGrp === 'AFC') && sellingPrice > partnerPrice && partnerPrice > 0) {
      finalSellingPrice = partnerPrice;
      var discountTit = partnerGrp === 'AFC' ? '복지몰' : '임직원';
      $('#maxBenefitRentalPop header.pop-header h4.tit span').text(discountTit + ' 최대혜택가');
      discountArea.append('<li><span class="txt">' + discountTit + ' 할인</span><span class="won">-' + vcui.number.addComma(sellingPrice - partnerPrice) + '원</span></li>');
      $('#maxBenefitRentalPop #maxBenefitRentalNoReorderMsg').show();
    } else if (sellingPrice > reorderPrice && reorderPrice > 0 && reorderFlag === 'Y') {
      finalSellingPrice = reorderPrice;
      discountArea.append('<li><span class="txt">재구독 할인</span><span class="won">월 -' + vcui.number.addComma(sellingPrice - reorderPrice) + '원</span></li>');
    } else if (sellingPrice > linkOrderPrice && linkOrderPrice > 0 && linkOrderFlag === 'Y') { // BTOCSITE-73594 [개발] [구독] 가전 연계 구독 할인
      finalSellingPrice = linkOrderPrice;
      discountArea.append('<li><span class="txt">가전 연계 구독 할인</span><span class="won">월 -' + vcui.number.addComma(sellingPrice - linkOrderPrice) + '원</span></li>');
    }

    if (rentalCareMaxSalePrice > 0) {
      var realRentalCareMaxSalePrice = finalSellingPrice > rentalCareMaxSalePrice ? rentalCareMaxSalePrice : finalSellingPrice;
      discountArea.append('<li><span class="txt">제휴카드 할인</span><span class="won">월 최대 -' + vcui.number.addComma(realRentalCareMaxSalePrice) + '원</span></li>');
      finalSellingPrice -= rentalCareMaxSalePrice;
    }

    if (finalSellingPrice < 0) {
      finalSellingPrice = 0;
    }
    
    $('#maxBenefitRentalPop div.max-benefit-price span.won').html('월 ' + vcui.number.addComma(finalSellingPrice) + '원');
    $('#maxBenefitRentalPop').vcModal("show");
  });
});